import QueueAppointmentsPage from './QueueAppointmentsPage.js'
export default QueueAppointmentsPage
